import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import { ChargeDialogComponent } from './charge-dialog.component'
import { CreateChargePayload, ChargeResponse } from '@tokeet-frontend/charges'

@Injectable()
export class ChargeDialogService {
  constructor(private dialog: DialogService) {}

  open(data?: { charge?: ChargeResponse; duplicate?: boolean; defaults?: Partial<CreateChargePayload> }) {
    const defaultConfig: MatDialogConfig = {
      width: '550px',
      height: 'auto',
      data: { ...data },
    }

    return this.dialog.openVariableDialog(ChargeDialogComponent, defaultConfig)
  }
}
